<template>

  <div class="form-group">
    <div class="col-4 mb-2">
      <label for="log-amount">Aantal</label>
      <div class="input-group  ">
        <div class="input-group-prepend">
          <button :disabled="log.amount <= 1" class="btn btn-light" type="button" @click="log.amount--"><i
              class="fas fa-minus"></i></button>
        </div>
        <input
            @change="log.amount= $event.target.value  < 0  ?   1 : $event.target.value "
            id="log-amount" type="number" class="form-control" v-model.number="log.amount">
        <div class="input-group-append">
          <button class="btn btn-light" type="button" @click="log.amount++"><i class="fas fa-plus"></i></button>
        </div>
      </div>
    </div>

    <div class="col-8 mb-2">
      <label for="group"> Reden</label>
      <select class="form-control" id="group" v-model="log.reason">
        <optgroup v-for="reason in getReasonsForJob.children" :label="reason.translations && reason.translations[getLocale]  ? reason.translations[getLocale] : reason.name">
          <option v-for="child in reason.children" :value="child.name">{{ child.translations && child.translations[getLocale]  ? child.translations[getLocale] : child.name }}</option>
        </optgroup>
      </select>

    </div>

    <div class="  col-md-4 col-xs-12 col-sm-12 mb-2">
      <label for="log-time">{{ $t('ui.time') }}</label>

      <div class="input-group  ">

        <div class="input-group-prepend">
          <button class="btn" type="button" :class='isSelected("-")' @click="timerOperator = '-' "><i
              class="fas fa-minus"></i>
          </button>
        </div>

        <input id="log-time" type="text" class="form-control" :value="getTimerValue" disabled style="background:white">

        <div class="input-group-append">
          <button class="btn " type="button" @click="timerOperator = '+' " :class='isSelected("+")'>
            <i class="fas fa-plus"></i>
          </button>
        </div>
      </div>
    </div>
    <!--    <div class="col-2">-->

    <!--      <label for="timeType">Eenheid</label>-->
    <!--      <div class="button-group ">-->
    <!--        <button class="btn btn-block" :class="log.time.type ==='min' ?' btn-secondary' :  ''"-->
    <!--                @click="log.time.type = 'min'">Min-->
    <!--        </button>-->
    <!--        <button class="btn  btn-block" :class="log.time.type ==='hour' ?' btn-secondary' :  ''"-->
    <!--                @click="log.time.type = 'hour'">Hour-->
    <!--        </button>-->
    <!--      </div>-->
    <!--      &lt;!&ndash;      <select name="timeType" class="form-control" id="timeType" v-model="log.time.type">&ndash;&gt;-->
    <!--      &lt;!&ndash;        <option :key="idx+timeType.text" v-for="(timeType,idx) in timeTypes" :value="timeType.value">&ndash;&gt;-->
    <!--      &lt;!&ndash;          {{ timeType.text }}&ndash;&gt;-->
    <!--      &lt;!&ndash;        </option>&ndash;&gt;-->
    <!--      &lt;!&ndash;      </select>&ndash;&gt;-->
    <!--    </div>-->

    <div class="col-xs-12  col-md-8 mb-2 ">


      <label for="">{{ timerOperator == '+' ? $t('jobs.detail.reasons.addMinutes') :  $t('jobs.detail.reasons.subtractMinutes')}} </label>
      <div class="row minute-buttons mb-2">
        <div class="minute-btn-col mb-2">
          <button class="btn btn-light btn-block rounded" @click="setTime(1)"> {{ timerOperator }} 1 min
          </button>
        </div>
        <div class="minute-btn-col mb-2">
          <button class="btn btn-light btn-block rounded" @click="setTime(5)">{{ timerOperator }} 5 min
          </button>
        </div>
        <div class="minute-btn-col mb-2">
          <button class="btn btn-light btn-block rounded" @click="setTime(15)">{{ timerOperator }} 15 min
          </button>
        </div>
        <div class="minute-btn-col mb-2">
          <button class="btn btn-light btn-block rounded" @click="setTime(30)"> {{ timerOperator }} 30 min
          </button>
        </div>
        <div class="minute-btn-col mb-2">
          <button class="btn btn-light btn-block rounded" @click="setTime(60)"> {{ timerOperator }} 60 min
          </button>
        </div>
        <!--        <div class="col">-->
        <!--          <button class="btn  btn-block " :class="isSelected(5,'hour')" @click="setTime(5,'hour')"> 5 hour-->
        <!--          </button>-->
        <!--        </div>-->
      </div>
    </div>
    <div class="col-12 mt-3   ">
      <button class="btn btn-danger   float-right" @click="$emit('deleteReason',idx)"><i class="far fa-trash-alt "></i>
        {{ $t('jobs.detail.reasons.reason') }}
      </button>
    </div>

  </div>

</template>

<script>
import timeCalc from "@/mixins/timeCalc";
import {mapGetters} from 'vuex'

export default {
  mixins: [timeCalc],
  name: "JobReasonLog",
  props: [
    'log',
    'job',
    'idx'
  ],
  data() {
    return {
      show: false,
      timerOperator: '+',
      timeInMs: 0,
      timeTypes: [
        {
          value: 'min',
          text: 'Minute(s)'
        },
        {
          value: 'hour',
          text: 'Hour(s)'
        }
      ],


    }
  },
  methods: {
    enter: function (el, done) {

      var that = this;

      setTimeout(function () {
        that.show = false;
      }, 500); // hide the message after 3 seconds
    },
    isSelected(value) {
      return value == this.timerOperator ? ' btn-secondary' : ' btn-light'
    },
    setTime(value, type) {
      this.show = !this.show
      value = value * 60 * 1000

      if (this.timerOperator == "+") {
        this.log.timeInMs += value
      } else {
        this.log.timeInMs -= value
        if (this.log.timeInMs < 0) {
          this.log.timeInMs = 0
        }
      }
    },

  },
  computed: {
    ...mapGetters('userData', ['getLocale']),
    ...mapGetters('reasonTrees', ['getReasonTrees']),
    getReasonsForJob() {
      let reasons = _.filter(this.getReasonTrees, reasonTree => {
        if (reasonTree.type === 'job') {
          return this.job.department === reasonTree.department || !this.job.department
        }
      })
      return reasons[0]
    },
    getTimerValue() {
      return this.convertMs(this.log.timeInMs).hrs + ':' + this.convertMs(this.log.timeInMs).min
    }
  }
}
</script>

<style scoped>


input {
  text-align: center;
  line-height: 75px;
  display: block;
  /*background: #fff;*/
  /*color: #000;*/
  font-weight: 700;
  /*font-size: 3rem;*/
}


/*  hiding arrows*/
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.form-group {
  margin-bottom: 25px;
}

label {
  font-size: 1.8rem;
  color: #000;
  font-weight: 600;
}

.input-group button {
  border-color: #e4e4e4;
}

.btn-light {
  color: #000;
  background-color: #e9ecef;
}

.minute-buttons {
  display: flex;
  flex-wrap: wrap;
}

.minute-btn-col {
  flex: 1 0 140px;
  padding-left: 15px;
  padding-right: 15px;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 1s;

}

.fade-enter,
.fade-leave-to
  /* .fade-leave-active in <2.1.8 */

{

  opacity: 0
}
</style>

<!--<transition name="fade" v-on:enter="enter">-->
<!--<i class="fas fa-plus text-right" style="display:inline-block;"></i>-->
<!--</transition>-->